import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import SettingsMenuComponent from '../components/SettingsMenu/SettingsMenuComponent';
import UserSettingsPage from './UserSettingsPage';
import TradeReportPage from './TradeReportPage';
// import TradeSettingsPage from '@t7x000/apex-web/lib/components/Settings/TradeSettings';
import APIKeysPage from './APIKeysPage';
import UserContactsPage from './UserContactsPage';
// import AffiliateProgramPage from './AffiliateProgramPage';
// import LoyaltyTokenPage from './LoyaltyTokenPage';
// import DemoSettingsContainer from '@t7x000/apex-web/lib/components/Settings/DemoSettings/DemoSettingsContainer';
// import InterestBearingAccountsSettingsContainer from '@t7x000/apex-web/lib/components/Settings/InterestBearingAccounts/';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import { marginSystemEnabledSelector } from '@t7x000/apex-web/lib/redux/margin/selectors/index.js';
import KYCSettings from '@t7x000/apex-web/lib/components/KYCSettings';
import { selectIsShowApiKeys } from '../redux/selectors/userConfigSelector';
import { kycVerificationLevelsSelector } from '@t7x000/apex-web/lib/redux/selectors/kycLevelsSelectors';
import './SettingsPage.css';

const settingsPageClasses = getBEMClasses('settings-page');

const SettingsPage = ({ systemMarginEnabled, isShowApiKeys }) => {
  return (
    <React.Fragment>
      <div className={settingsPageClasses('container')}>
        <div className={settingsPageClasses('menu')}>
          <SettingsMenuComponent systemMarginEnabled={systemMarginEnabled} />
        </div>
        <div className={settingsPageClasses('content')}>
          <Route path={'/settings/user'} component={UserSettingsPage} />
          {/* {systemMarginEnabled && <Route path="/settings/trade" component={TradeSettingsPage} />} */}
          {/* <Route path="/settings/iba" component={InterestBearingAccountsSettingsContainer} /> */}
          <Route path={'/settings/trade-reports'} component={TradeReportPage} />
          {isShowApiKeys && <Route path={'/settings/api-keys'} component={APIKeysPage} />}
          <Route path={'/settings/contacts'} component={UserContactsPage} />
          {/* <Route path={'/settings/affiliate'} component={AffiliateProgramPage} /> */}
          {/* <Route path={'/settings/loyalty-token'} component={LoyaltyTokenPage} /> */}
          <Route path={'/settings/verification-level'} component={KYCSettings} />
          {/* <Route path={'/settings/demo-settings'} component={DemoSettingsContainer} /> */}
        </div>
      </div>
      <PageFooterLayout />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { verificationLevel } = kycVerificationLevelsSelector(state);
  const isShowApiKeys = selectIsShowApiKeys(state);

  return {
    verificationLevel,
    isShowApiKeys: (verificationLevel && Number(verificationLevel) === 99) || isShowApiKeys,
    systemMarginEnabled: marginSystemEnabledSelector(state),
  };
};

export default connect(mapStateToProps)(SettingsPage);
